import { Component, Inject, inject, PLATFORM_ID } from '@angular/core';
import { PageEvent, MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { Router, RouterLink, RoutesRecognized } from '@angular/router';
import { Package } from 'app/core/shared-services/shared-interface.types';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { StrapiService } from 'app/core/shared-services/strapi.service';
import { MatButtonModule } from '@angular/material/button';
import { isPlatformBrowser, Location, LowerCasePipe, NgFor, NgForOf, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardComponent } from '@fuse/components/card';
import { NgClass } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { BoldKeywordsPipe } from 'app/core/pipes/boldKeywordspipe';
import { SwiperPackagesComponent } from '../dashboard/package-options/swiper-packages/swiper-packages.component';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { filter, pairwise } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-deals',
  standalone: true,
  imports: [
    RouterLink, MatButtonModule, NgIf, NgForOf, NgFor, MatIconModule, 
    FuseCardComponent, NgClass, LowerCasePipe,MatDividerModule, MatPaginatorModule, SwiperPackagesComponent,
    BoldKeywordsPipe, RouterLink
  ],
  templateUrl: './deals.component.html',
  styleUrl: './deals.component.scss'
})
export class DealsComponent {

  public headerImage: string;
  public headerTitle: string;
  public headerTextColor: string;
  public description: any;
  public loading: boolean = true;
  public deals: any[] = [];
  public dealPageBanners: any[] = [];
  public dealsCategoryTypes: any[] = [];

  private referrer: string;

    // ## DEPENDENCIES ##
    private _strapiService = inject(StrapiService);
    private _sharedMethods = inject(SharedMethodsModule);
    private location = inject(Location);
    public _router = inject(Router);
    public _gtmService = inject(GtmService);


    constructor(
      @Inject(PLATFORM_ID) private platformId: any
    ){}


  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {

      if(localStorage.getItem('currentURL')) {
        if(localStorage.getItem('currentURL') == window.location.href) {
          //this.referrer = window.location.href
        } else {
          this.referrer = localStorage.getItem('currentURL')
          localStorage.setItem('currentURL', window.location.href);
          localStorage.setItem('previousURL', this.referrer);
        }
      } else {
        localStorage.setItem('currentURL', window.location.href);
      }

      const route = window.location.href;
      const path = this._router.url;
      this._gtmService.pushEvent({ 
        event: 'page_view',
        page_url: route,
        page_path: path,
        page_title: 'deals_page',
        page_referrer: this.referrer ? this.referrer : route
      });
    }

    // this._strapiService.GetProductsContent()
    this._strapiService.getDealImages()
      .subscribe({
        next: (res: any) => {
          this.dealsCategoryTypes = []
          const deals = res.data.sort((b) => {b.renderPriority - b.renderPriority});

          // push cat titles to array
          deals.forEach(element => {
            this.dealsCategoryTypes.push({title: element.deals_category.categoryTitle})
          });

          this.deals = deals.reduce(function(results, dealsCategory) {
            (results[dealsCategory.deals_category.categoryTitle] = results[dealsCategory.deals_category.categoryTitle] || []).push(dealsCategory);
            return results;
          }, [])


          // filter duplicates
          this.dealsCategoryTypes = this.dealsCategoryTypes.filter(
            (obj, index) =>
              this.dealsCategoryTypes.findIndex((item) => item.title === obj.title) === index
          );

          this.loading = false;
          
        }
        
      });
  
      this._strapiService.getDealsScreenHeaderContent()
      .pipe(
        retry(3),
        catchError((err) => {
          console.error(err);
          this.loading = false;
          return of(null);
        })
      )
      .subscribe({
        next: (res: any) => {
          this.headerTitle = res.data?.headerText;
          this.headerImage = res.data?.image?.url;
          this.description = res.data?.bodyText;
          this.headerTextColor = res.data?.text_color_hex;

          this.loading = false;
        }
      });


      this._strapiService.getDealPageBanners()
      .subscribe({
        next: (res: any)=>{
          res.data.forEach(element => {
            this.dealPageBanners.push(element);
          });
      
        }
      })
  }
 
  // Private Methods
 

}
